export default __webpack_public_path__ + "2986c3eba296abfad6de0779075aeb21.png";